import styled from "styled-components";

export const Input = styled.input`
   border: none;
   outline: none;
   color: grey;
   padding: 0.7em;
   font-size: 1em;
   width: 100%;
   border-bottom: 1px solid grey;
   box-sizing: border-box;
   font-weight: 300;
   margin: 1em 0;
   background-color: transparent;

   &[type="date"]::-webkit-inner-spin-button {
      display: none;
   }
   &[type="date"]::-webkit-calendar-picker-indicator {
      color: #2c3e50;
   }

   &.readGhost {
      // background: red;
      border-bottom: transparent;
      cursor: initial;
      padding: 0;
      margin-top: 0.5em;
      font-size: 1.1em;
      font-weight: 600;

      &.principal {
         font-size: 1.2em;
      }
   }
`;

export const SelectStyled = styled.select`
   // reset
   -webkit-box-sizing: border-box;
   -moz-box-sizing: border-box;
   box-sizing: border-box;
   -webkit-appearance: none;
   -moz-appearance: none;

   border: none;
   outline: none;
   color: grey;
   padding: 0.7em;
   font-size: 1em;
   width: 100%;
   border-bottom: 1px solid grey;
   box-sizing: border-box;
   font-weight: 300;
   margin: 1em 0;

   background-image: linear-gradient(45deg, transparent 50%, gray 50%), linear-gradient(135deg, gray 50%, transparent 50%);
   background-position: calc(100% - 20px) calc(1em + 2px), calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;
   background-size: 5px 5px, 5px 5px, 1px 1.5em;
   background-repeat: no-repeat;

   /* background-image: linear-gradient(45deg, transparent 50%, gray 50%), linear-gradient(135deg, gray 50%, transparent 50%),
      radial-gradient(#ddd 70%, transparent 72%);
   background-position: calc(100% - 20px) calc(1em + 2px), calc(100% - 15px) calc(1em + 2px), calc(100% - 0.5em) 0.5em;
   background-size: 5px 5px, 5px 5px, 1.5em 1.5em;
   background-repeat: no-repeat; */
`;

export const TextArea = styled(Input)`
   width: 100%;
   height: 100px;
   // font-size: 1.1em;
   color: #7b7b7b;
   padding: 0.5em;
   font-family: Montserrat;
   resize: none;
`;
